import HeartEmptyIcon from "./HeartEmptyIcon.mjs";

/** @type {GlyphIcon} */
export default HeartEmptyIcon;